module.exports = __webpack_public_path__ + "static/img/11huanying.fe5a4239.gif";